import { notNull } from '@egr/xbox/utils/Types';

export function trackFileHoster(url: string) {
    const data = {
        category: 'File hoster',
        action: 'type',
        name: getFilehoster(url),
        value: undefined,
    };
    if (window._paq != null) {
        window._paq.push(['trackEvent', data.category, data.action, data.name, data.value].filter(notNull));
    }
}

type FileHoster = 'OWDS' | 'Dropbox' | 'OneDrive' | 'GoogleDrive' | 'SharePoint' | 'Others';
function getFilehoster(url: string): FileHoster {
    if (url.includes('owds.pcon-solutions.com/api/') || url.includes('owds.egr.eu/api/')) {
        return 'OWDS';
    } else if (url.includes('dropbox.com')) {
        return 'Dropbox';
    } else if (url.includes('1drv.ms') || url.includes('onedrive.live.com')) {
        return 'OneDrive';
    } else if (url.includes('drive.google.com')) {
        return 'GoogleDrive';
    } else if (url.includes('sharepoint.com')) {
        return 'SharePoint';
    } else {
        return 'Others';
    }
}

type ViewInteractionTypes =
    | 'Hide info hotspots'
    | 'Show info hotspots'
    | 'Show fullscreen'
    | 'Exit fullscreen'
    | 'Toggle rotation off'
    | 'Toggle rotation on'
    | 'Show floor plan'
    | 'Show 3D View'
    | 'Enter AR'
    | 'Exit AR'
    | 'Enter VR'
    | 'Exit VR'
    | 'Snapshot'
    | 'Open standalone'
    | 'Open thumb menu'
    | 'Close thumb menu'
    | 'Open Share'
    | 'Open Embed';

export function trackViewerInteraction(type: ViewInteractionTypes) {
    const data = {
        category: 'Viewer Interaction',
        action: 'click',
        name: type,
        value: undefined,
    };
    if (window._paq != null) {
        window._paq.push(['trackEvent', data.category, data.action, data.name, data.value].filter(notNull));
    }
}
